<template>
  <div class="rate-history-detail main-container">
    <loading :isShow="loading" />
    <div class="header">
      <span>产品名称：{{ pageQuery.productName }}</span>
      <span>产品编码： {{ pageQuery.productCode || '-' }}</span>
      <span>保司：{{ pageQuery.companyName || '-' }}</span>
      <span v-if="$units.superviseShowVal()">供应商：{{ pageQuery.supplierName || '-' }}</span>
      <Button @click="back(pageQuery.backUrl)" type="primary" ghost>返回</Button>
    </div>
    <rate-table ref="rateTable" :isEditAuth="false" :data="data" mode="base" type="1"></rate-table>
  </div>
</template>
  
<script>
import rateTable from '@/components/commons/feeTemplate/rateTable';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: { rateTable },
  props: {},
  data() {
    return {
      tabId: '1',
      loading: false,
      data: [],
      pageQuery: {},
      detaile: {}
    };
  },
  mounted() {
    this.pageQuery = this.$route.query;
    this.getData();
  },
  methods: {
    // 获取费率数据
    getData() {
      this.$http({
        url: '/buz/commission/queryVersionCommissionData',
        type: 'get',
        apiPermissionCode: 'pro_7_1',
        data: {
          versionId: this.pageQuery.versionId,
          productCode: this.pageQuery.productCode
        }
      }).then(res => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.rate-history-detail {
  .header {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    padding-right: 70px;
    position: relative;
    line-height: 30px;
    span {
      margin-right: 50px;
    }
    .ivu-btn {
      position: absolute;
      right: 0;
    }
  }
}
</style>